import { render } from "./TheOTheParnasIChoiceSmart_2025.vue?vue&type=template&id=5299ba7b"
const script = {}

import exportComponent from "/Users/taesungkim/Git/parnas-app-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__